export default __webpack_public_path__ + "static/logo-cfl-white-8e623378d372a82081ef3ae15607d249.svg";